import { PageBillingType } from '@mm/state/interfaces/connected-page';
import React from 'react';
import { useMatchBillingPlan } from '../../hooks/use-match-billing-plan';
import './ProRibbon.pcss';

export type ProRibbonType = 'pro' | 'unicorn' | 'beta' | 'team';

type Props = {
  ribbonType: ProRibbonType;
  className?: string;
};

const PRO_RIBBON_TEXTS: Record<ProRibbonType, string> = {
  pro: 'OPERATOR',
  unicorn: 'STARTUP',
  beta: 'BETA',
  team: 'AGENCY',
};

const levelsMap: { [key: string]: PageBillingType } = {
  pro: PageBillingType.Pro,
  unicorn: PageBillingType.ProUnicorn,
  team: PageBillingType.Team,
};

const ProRibbon = ({ className, ribbonType }: Props) => {
  const billingType = levelsMap[ribbonType];
  const match = useMatchBillingPlan(billingType);

  return match ? null : (
    <div className={`pro-ribbon pro-ribbon__${ribbonType} ${className || ''}`}>
      <span className="pro-ribbon__text">{PRO_RIBBON_TEXTS[ribbonType]}</span>
    </div>
  );
};

export default ProRibbon;
